var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { GGOBaseComponent } from '../ggo.base.component.js';
let DatePickerComponent = class DatePickerComponent extends GGOBaseComponent {
    static get styles() {
        return [
            ...super.styles,
            css `
          #datepicker {
            border-radius: .25rem;
            font-weight : 400;
            border: none;
            width: 7.5rem;
            padding:.2rem;
          }
          input:hover {
            box-shadow: 0 0 1px 1px #1B96FF;
          }
          input:focus-visible {
            outline-width: 0;
          }
          `,
        ];
    }
    render() {
        return html `<input id='datepicker' type="date" placeholder="Choisir une date" />`;
    }
};
DatePickerComponent = __decorate([
    customElement('ggo-datepicker')
], DatePickerComponent);
export { DatePickerComponent };
